import { render, staticRenderFns } from "./CompanyProfileForm.vue?vue&type=template&id=2a44e9bc&scoped=true&lang=pug&"
import script from "./CompanyProfileForm.vue?vue&type=script&lang=ts&"
export * from "./CompanyProfileForm.vue?vue&type=script&lang=ts&"
import style0 from "./CompanyProfileForm.vue?vue&type=style&index=0&id=2a44e9bc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a44e9bc",
  null
  
)

export default component.exports